import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';

import AppDigest from './AppDigest';
import { Link } from 'components/Common';
import VirtualizedList from 'components/VirtualizedList';
import { appsPerPage } from 'config';

const List = styled.div`
  ${({ borderTop, theme }) => theme.AppList({ borderTop })};
`;

const SortItem = SortableElement(AppDigest);

const SortList = SortableContainer(({ apps, borderTop, appDigestProps }) => (
  <List borderTop={borderTop}>
    {apps.map((app, index) => (
      <SortItem app={app} index={index} key={app.id} {...appDigestProps} />
    ))}
  </List>
));

const SortableAppList = (props) => <SortList hideSortable={false} {...props} />;

const Item = ({ app, style, ...props }) => (
  <Link
    style={style}
    to={`/app/${app.id}`}
    pageDirection="FORWARD"
    data-test-type="app-link"
    data-test-id={app.id}
  >
    <AppDigest app={app} {...props} />
  </Link>
);

export const AppList = ({
  apps,
  borderTop,
  previous = '',
  sortable,
  appDigestProps,
  onSortEnd
}) => {
  if (sortable) {
    return (
      <SortableAppList
        apps={apps}
        appDigestProps={appDigestProps}
        borderTop={borderTop}
        onSortEnd={onSortEnd}
      />
    );
  }

  return (
    <List borderTop={borderTop}>
      {apps.map((app) => (
        <Item app={app} key={app.id} previous={previous} {...appDigestProps} />
      ))}
    </List>
  );
};

AppList.propTypes = {
  apps: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  sortable: PropTypes.bool,
  appDigestProps: PropTypes.shape({
    onRemove: PropTypes.func,
    showInstalled: PropTypes.bool,
    showUpdate: PropTypes.bool,
    showSettings: PropTypes.bool
  }),
  onSortEnd: PropTypes.func
};

class VirtualizedAppList extends Component {
  isItemLoaded = ({ index }) => {
    const { apps } = this.props;
    return !!apps[index];
  };

  render() {
    const { apps, hasNextPage, appDigestProps, fetchMore } = this.props;

    const appsCount = apps.length;

    return (
      <VirtualizedList
        currentCount={appsCount}
        maxCount={hasNextPage === false ? appsCount : undefined}
        pageSize={appsPerPage}
        pageLoadThreshold={8}
        isItemLoaded={this.isItemLoaded}
        fetchMore={fetchMore}
      >
        {({ index, style }) => (
          <Item app={apps[index]} style={style} {...appDigestProps} />
        )}
      </VirtualizedList>
    );
  }
}

export default VirtualizedAppList;
